module.exports = __webpack_public_path__ + "img/30x30_kirmizi.52b93702.gif";